import React from 'react';

import styles from './GameSceneInfo.scss';
import ConnectedFormattedMessage from 'Containers/ConnectedFormattedMessage';

const GameSceneInfo = ({ slug, scene }) => (
  <div className="GameSceneInfo">
    <div className="GameSceneInfo__title">
      <ConnectedFormattedMessage id={`model.${slug}.scenes.${scene}.title`} />
    </div>
    <div className="GameSceneInfo__label">
      <ConnectedFormattedMessage
        id={`model.${slug}.scenes.${scene}.label`}
        containsHtml
      />
    </div>
  </div>
);

export default GameSceneInfo;
